export default __webpack_public_path__ + "static/media/Facerecongition.69835f8e.png";